import React from "react";
import { withRouter, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faEllipsisV,
    faTable,
    faCaretUp,
    faCaretDown,
    faChartBar,
} from "@fortawesome/free-solid-svg-icons";
import Table from "react-bootstrap/Table";
import TotalOfficeStockBuild from "../../widgets/retail/TotalOfficeStockBuild";
import CurrentVacancy from "../../widgets/retail/CurrentVacancy";
import CurrentPassingRent from "../../widgets/retail/CurrentPassingRent";
import UpcomingSupply from "../../widgets/retail/UpcomingSupply";

class Region extends React.Component {
    render() {
        return (
            <div className="container-fluid region">
                <div className="row">
                    <div className="col-lg-9">
                        <div className="row">
                            <div class="col-lg-3 mb-4">
                                <TotalOfficeStockBuild />
                            </div>
                            <div class="col-lg-3 mb-4">
                                <CurrentVacancy />
                            </div>
                            <div class="col-lg-3 mb-4">
                                <CurrentPassingRent />
                            </div>
                            <div class="col-lg-3 mb-4">
                                <UpcomingSupply />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="widget widgetGraph">
                                    <div className="row">
                                        <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                            <p>
                                                Ofﬁce Demand & Supply <span>(All Grades)</span>
                                            </p>
                                            <h4 className="colorGreen">
                                                <FontAwesomeIcon icon={faCaretUp} size="lg" />
                                                14%
                                            </h4>
                                            <p className="colorBlack pSmall">M-o-m vs Q1 CY’19</p>
                                        </div>
                                        <div className="col-lg-3 text-end">
                                            <Link to="/#">
                                                <FontAwesomeIcon icon={faTable} />
                                            </Link>
                                            <Link to="/#" className="colorBlack">
                                                <FontAwesomeIcon icon={faEllipsisV} />
                                            </Link>
                                        </div>
                                        <div className="col-lg-12">
                                            {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="widget widgetGraph">
                                    <div className="row">
                                        <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                            <p>Rentals</p>
                                            <h4 className="colorRed">
                                                <FontAwesomeIcon icon={faCaretDown} size="lg" />
                                                -4%
                                            </h4>
                                            <p className="colorBlack pSmall">M-o-m vs Q1 CY’19</p>
                                        </div>
                                        <div className="col-lg-3 text-end">
                                            <Link to="/#">
                                                <FontAwesomeIcon icon={faTable} />
                                            </Link>
                                            <Link to="/#" className="colorBlack">
                                                <FontAwesomeIcon icon={faEllipsisV} />
                                            </Link>
                                        </div>
                                        <div className="col-lg-12">
                                            {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 rightSideBar">
                        <div class="widget widgetRightSideBar text-start mb-4">
                            <div class="row">
                                <div class="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>New Completions</p>
                                </div>
                                <div class="col-lg-3 text-end">
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div class="col-lg-12 mt-4 colorBlack tableCompletion">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Complex</th>
                                                <th>Area</th>
                                                <th>Micro-Market</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>DLF Downtown Phase - II</td>
                                                <td>0.6 msf</td>
                                                <td>Golf Course Road</td>
                                            </tr>
                                            <tr className="">
                                                <td>DLF Downtown Phase - II</td>
                                                <td>0.6 msf</td>
                                                <td>Golf Course Road</td>
                                            </tr>
                                            <tr className="">
                                                <td>DLF Downtown Phase - II</td>
                                                <td>0.6 msf</td>
                                                <td>Golf Course Road</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-4">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Office Stock</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#" className="pe-3">
                                        <FontAwesomeIcon icon={faChartBar} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Grade</th>
                                                <th>Building</th>
                                                <th>Area</th>
                                                <th>Passing Rent</th>
                                                <th>Market Rent</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>A+</td>
                                                <td>192</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                            <tr className="">
                                                <td>A+</td>
                                                <td>192</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                            <tr className="">
                                                <td>A+</td>
                                                <td>192</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                            <tr className="">
                                                <td>A+</td>
                                                <td>192</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td>Total</td>
                                                <td>310</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                        </tfoot>
                                    </Table>
                                </div>
                            </div>
                        </div>
                        <div className="widget widgetGraph mt-4">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Grade-ewise Office Absorption Trend</p>
                                    <h4 className="colorGreen">
                                        <FontAwesomeIcon icon={faCaretUp} size="lg" />
                                        14%
                                    </h4>
                                    <p className="colorBlack pSmall">M-o-m vs Q1 CY’19</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#">
                                        <FontAwesomeIcon icon={faTable} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12">
                                    {/* <Bar
                        options={this.state.chartOtions}
                        data={this.state.chartData}
                      /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Projects</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Building</th>
                                                <th>Area (msf)</th>
                                                <th>Completion</th>
                                                <th>Current Rent</th>
                                                <th>Occupancy</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="tableTdColor ">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>

                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="tableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div class="widget widgetRightSideBar widgetGreen text-start mb-4">
                            <div class="row">
                                <div class="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Summary</p>
                                </div>
                                <div class="col-lg-3 text-end">
                                    <Link to="/#" className="colorWhite">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div class="col-lg-12 mt-4 colorBlack tableCompletion">
                                    <Table responsive hover>
                                        <tbody>
                                            <tr className="">
                                                <td># of Assets</td>
                                                <td>82</td>
                                            </tr>
                                            <tr className="">
                                                <td># of Active Leases</td>
                                                <td>1,892(7.2 msf)</td>
                                            </tr>
                                            <tr className="">
                                                <td># of Inctive Leases</td>
                                                <td>892(5.2 msf)</td>
                                            </tr>
                                            <tr className="">
                                                <td># of Sales Transaction</td>
                                                <td>82(2.3 msf)</td>
                                            </tr>
                                            <tr className="">
                                                <td>Occupancy</td>
                                                <td>82%</td>
                                            </tr>
                                            <tr className="">
                                                <td>Wt. Avg Current Rent</td>
                                                <td>102</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 mapContainer mb-4 mt-4">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d30711058.69295036!2d64.4487244350266!3d20.012353286203773!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff06b92b791%3A0xd78c4fa1854213a6!2sIndia!5e0!3m2!1sen!2sin!4v1640941177663!5m2!1sen!2sin"
                            width="100%"
                            height="600"
                            style={{ border: "0", loading: "lazy" }}
                        ></iframe>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-6">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Future Supply</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#" className="pe-3">
                                        <FontAwesomeIcon icon={faChartBar} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Grade</th>
                                                <th>3 Months</th>
                                                <th>6 Months</th>
                                                <th>9 Months</th>
                                                <th>12 Months</th>
                                                <th>24 Months</th>
                                                <th>36 Months</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>A+</td>
                                                <td>192</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                            <tr className="">
                                                <td>A+</td>
                                                <td>192</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                            <tr className="">
                                                <td>A+</td>
                                                <td>192</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                            <tr className="">
                                                <td>A+</td>
                                                <td>192</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="widget widgetTable tableBlue">
                            <div className="row">
                                <div className="col-lg-9 text-start widgetTableHeader">
                                    <p>Upcoming Project Completions</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#" className="pe-3 colorWhite">
                                        <FontAwesomeIcon icon={faChartBar} />
                                    </Link>
                                    <Link to="/#" className="colorWhite">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Complex</th>
                                                <th>Leaseable Area</th>
                                                <th>Completion Date</th>
                                                <th>Micro-Market</th>
                                                <th>Config</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>DLF Downtown Phase - II</td>
                                                <td>0.6 msf</td>
                                                <td>Dec 2021</td>
                                                <td>XYZ Vihar</td>
                                                <td>3B + G + 11</td>
                                            </tr>
                                            <tr className="">
                                                <td>DLF Downtown Phase - II</td>
                                                <td>0.6 msf</td>
                                                <td>Dec 2021</td>
                                                <td>XYZ Vihar</td>
                                                <td>3B + G + 11</td>
                                            </tr>
                                            <tr className="">
                                                <td>DLF Downtown Phase - II</td>
                                                <td>0.6 msf</td>
                                                <td>Dec 2021</td>
                                                <td>XYZ Vihar</td>
                                                <td>3B + G + 11</td>
                                            </tr>
                                            <tr className="">
                                                <td>DLF Downtown Phase - II</td>
                                                <td>0.6 msf</td>
                                                <td>Dec 2021</td>
                                                <td>XYZ Vihar</td>
                                                <td>3B + G + 11</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 mt-4">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Year-Wise Analysis</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#" className="pe-3">
                                        <FontAwesomeIcon icon={faChartBar} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Year</th>
                                                <th>Year-end Stock</th>
                                                <th>Gross Leasing</th>
                                                <th>Avg. Market Rent</th>
                                                <th>New Supply</th>
                                                <th>Leasing in New Supply</th>
                                                <th>Avg. Lease Rental in New Supply</th>
                                                <th>Top New Complexes</th>
                                                <th>Top Tenants</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>2015</td>
                                                <td>123.1</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                            </tr>
                                            <tr className="">
                                                <td>2015</td>
                                                <td>123.1</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                            </tr>
                                            <tr className="">
                                                <td>2015</td>
                                                <td>123.1</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                            </tr>
                                            <tr className="">
                                                <td>2015</td>
                                                <td>123.1</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 mt-4">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Top 10 Projects</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#" className="pe-3">
                                        <FontAwesomeIcon icon={faChartBar} />
                                    </Link>
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Name</th>
                                                <th>Developer</th>
                                                <th>Leasable Area</th>
                                                <th>Occupied Area</th>
                                                <th>Occupancy</th>
                                                <th>Rentals</th>
                                                <th>Lease Term</th>
                                                <th>Lock-in Period</th>
                                                <th>Security Deposit</th>
                                                <th>Anchor Tenants</th>
                                                <th>Anchor Rent</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="">
                                                <td>2015</td>
                                                <td>123.1</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                            </tr>
                                            <tr className="">
                                                <td>2015</td>
                                                <td>123.1</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                            </tr>
                                            <tr className="">
                                                <td>2015</td>
                                                <td>123.1</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                            </tr>
                                            <tr className="">
                                                <td>2015</td>
                                                <td>123.1</td>
                                                <td>117.2</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>71.3</td>
                                                <td>82.6</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                                <td>
                                                    DLF IT Park, Ambience Corp Spaze IT Park, TRIL Centre
                                                </td>
                                                <td>HCL, Accenture, Microsoft, NTT Data</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Major Recent Lease Transactions</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Tenant</th>
                                                <th>Date</th>
                                                <th>Complex</th>
                                                <th>ChargeableArea (sqft)</th>
                                                <th>Rent (₹/sqft/month)</th>
                                                <th>City</th>
                                                <th>Term</th>
                                                <th>Security Deposit</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="regionTableTdColor ">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="regionTableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="regionTableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="regionTableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className="regionTableTdColor">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="widget widgetTable">
                            <div className="row">
                                <div className="col-lg-9 text-start colorLightBlue widgetTableHeader">
                                    <p>Top Office Tenants</p>
                                </div>
                                <div className="col-lg-3 text-end">
                                    <Link to="/#" className="colorBlack">
                                        <FontAwesomeIcon icon={faEllipsisV} />
                                    </Link>
                                </div>
                                <div className="col-lg-12 mt-2">
                                    <Table responsive hover>
                                        <thead>
                                            <tr className="">
                                                <th>Tenant</th>
                                                <th>Current Rent</th>
                                                <th>Area Leased</th>
                                                <th>Last 2 Yrs. Rent</th>
                                                <th>Wale</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className=" ">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className=" ">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className=" ">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                            <tr className=" ">
                                                <td>ASF Insignia - B</td>
                                                <td>3.2</td>
                                                <td>Dec - 20</td>
                                                <td>92</td>
                                                <td>70%</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Region);
